import { Directive, AfterViewInit, ElementRef } from '@angular/core';
 
@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {
 
  constructor(private el: ElementRef) {
    console.log(el);
  }
 
  ngAfterViewInit() {
    setTimeout(() => {
        this.el.nativeElement.focus();
      }, 500);
  }
 
}
